import templateUrl from './editor-description-page.html';

export const editorDescriptionPageComponent = {
    bindings: {
        details: '<'
    },

    templateUrl,

    controller: class EditorDescriptionPageComponent {
        constructor(EditorDescriptionPageService) {
            'ngInject';

            this.editorDescriptionPageService = EditorDescriptionPageService;
        }

        $onInit() {
            this.details = this.editorDescriptionPageService.getDetails(this.details);
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/editor-description-page/editor-description-page.component.js